<template>
  <table cellpadding="0" cellspacing="0">
    <tr class="border">
      <th>Options to obtain citizenship</th>
      <td v-for="({ name, link }, index) in body" :key="index">
        <router-link target="_blank" :to="`/citizenship/${link}`">{{ name }}</router-link>
      </td>
    </tr>
    <tr class="border">
      <th>Via Donation program (EUR)</th>
      <td v-for="({ donation }, index) in body" :key="index">
        <template v-if="donation">{{ donation }}</template>
        <div v-else class="false"/>
      </td>
    </tr>
    <tr>
      <th>Via investment in real estate </th>
      <td :colspan="body.length"/>
    </tr>
    <tr>
      <th class="normal">(EUR)</th>
      <td v-for="({ investment }, index) in body" :key="index">
        <template v-if="investment">{{ investment }}</template>
        <div v-else class="false"/>
      </td>
    </tr>
    <tr class="border">
      <th class="normal">Holding period (years)</th>
      <td v-for="({ holdingPeriod }, index) in body" :key="index">
        <template v-if="holdingPeriod">{{ holdingPeriod }}</template>
        <div v-else class="false"/>
      </td>
    </tr>
    <tr class="border">
      <th>Timeframe (months)</th>
      <td v-for="({ timeframe }, index) in body" :key="index">
        {{ timeframe }}
      </td>
    </tr>
    <tr class="border">
      <th>Required residence in the country</th>
      <td v-for="({ requiredResidence }, index) in body" :key="index">
        <div v-if="index===0" >5 days during 5 years</div>
        <div v-else-if="requiredResidence" class="true"/>
        <div v-else class="false"/>
      </td>
    </tr>
    <tr>
      <th>Visa free travel to</th>
      <td :colspan="body.length"/>
    </tr>
    <tr>
      <th class="normal">Visa free countries and territories</th>
      <td v-for="({ visaCountries }, index) in body" :key="index">
        {{ visaCountries }}
      </td>
    </tr>
    <tr>
      <th class="normal">Including: EU</th>
      <td v-for="({ visaEU }, index) in body" :key="index">
        <div v-if="visaEU" class="true"/>
        <div v-else class="false"/>
      </td>
    </tr>
    <tr>
      <th class="normal">Including: UK</th>
      <td v-for="({ visaUK }, index) in body" :key="index">
        <div v-if="visaUK" class="true"/>
        <div v-else class="false"/>
      </td>
    </tr>
    <tr class="border">
      <th class="normal">Including: USA</th>
      <td v-for="({ visaUSA }, index) in body" :key="index">
        <div v-if="visaUSA" class="true"/>
        <div v-else class="false"/>
      </td>
    </tr>
    <tr>
      <th>Nationalities, not allowed to beinvolved in the program</th>
      <td v-for="({ blacklist }, index) in body" :key="index">
        <div v-if="!blacklist.length" class="false"/>
        {{ blacklist.join(', ') }}
      </td>
    </tr>
  </table>
</template>

<script>
export default {
  data: () => ({
    body: [
      {
        name: 'Antigua & Burbuda',
        link: 'antigua-and-barbuda-citizenship-investment-programme',
        donation: '100 000*',
        investment: '400 000**',
        holdingPeriod: 5,
        timeframe: '3-4',
        requiredResidence: '5 days during 5 years',
        requiredResidenceCheck: false,
        visaCountries: 150,
        visaEU: true,
        visaUK: true,
        visaUSA: false,
        blacklist: ['Afghanistan', 'Iran', 'Iraq', 'North Korea', 'Yemen', 'Sudan'],
      },
      {
        name: 'Dominica',
        link: 'dominica',
        donation: '100 000*',
        investment: '200 000**',
        holdingPeriod: 3,
        timeframe: '3-4',
        requiredResidence: false,
        requiredResidenceCheck: true,
        visaCountries: 137,
        visaEU: true,
        visaUK: true,
        visaUSA: false,
        blacklist: [],
      },
      {
        name: 'Grenada',
        link: 'grenada',
        donation: '150 000*',
        investment: '350 000**',
        holdingPeriod: 4,
        timeframe: '3-4',
        requiredResidence: false,
        requiredResidenceCheck: true,
        visaCountries: 143,
        visaEU: true,
        visaUK: true,
        visaUSA: false,
        blacklist: [],
      },
      {
        name: 'Sant Kitts and Nevis',
        link: 'Sant-Kitts-and-Nevis',
        donation: '150 000*',
        investment: "400 000** / 200 000**",
        holdingPeriod: "5/7",
        timeframe: '4-6',
        requiredResidence: false,
        visaCountries: 152,
        visaEU: true,
        visaUK: true,
        visaUSA: false,
        blacklist: ["Afghanistan", "Iran", "North Korea"],
      },
      {
        name: 'Saint Lucia',
        link: 'saint-lucia',
        donation: '100 000*',
        investment: '300 000**',
        holdingPeriod: '5',
        timeframe: '4-6',
        requiredResidence: false,
        requiredResidenceCheck: true,
        visaCountries: 145,
        visaEU: true,
        visaUK: true,
        visaUSA: false,
        blacklist: [],
      },
      {
        name: 'Vanuatu',
        link: 'vanuatu',
        donation: '150 000*',
        investment: false,
        holdingPeriod: false,
        timeframe: '6-7',
        requiredResidence: false,
        requiredResidenceCheck: true,
        visaCountries: 129,
        visaEU: true,
        visaUK: true,
        visaUSA: false,
        blacklist: ['Iran', 'Iraq', 'North Korea', 'Syria', 'Yemen'],
      },
      {
        name: 'Malta',
        link: 'malta',
        donation: false,
        investment: '1 300 000**',
        holdingPeriod: '5',
        timeframe: '6-12',
        requiredResidence: true,
        requiredResidenceCheck: true,
        visaCountries: 182,
        visaEU: true,
        visaUK: true,
        visaUSA: true,
        blacklist: ['North Korea', 'Afghanistan', 'Iran', 'Iraq', 'Livia', 'Somali', 'Sudan', 'Syria', 'Yemen'],
      },
      {
        name: 'Cyprus',
        link: 'cyprus',
        donation: false,
        investment: '2 250 000**',
        holdingPeriod: '3',
        timeframe: '6-8',
        requiredResidence: true,
        requiredResidenceCheck: true,
        visaCountries: 173,
        visaEU: true,
        visaUK: true,
        visaUSA: false,
        blacklist: ['North Korea', 'Sudan', 'Somali', 'Turkey'],
      },
    ],
  }),
}
</script>

<style lang="scss" scoped>
@import '@/assets/mixins.scss';

.false {
  width: 13px;
  height: 12px;
  background: url('../assets/icons/no.png') no-repeat center;
  margin: auto;
}

.true {
  width: 17px;
  height: 13px;
  background: url('../assets/icons/yes.png') no-repeat center;
  margin: auto;
}

a {
  font-size: 13px;
  text-decoration: underline;
  color: #202020;
  font-weight: 600;

  &.router-link-active {
    color: #83ca54;
  }
}

table {
  table-layout: fixed;
  width: 100%;
  font-size: 14px;
  margin: 10px 0;

  @include mobile {
    display: none;
  }
}

tr.border {
  th, td {
    border-bottom: 1px solid #d9dade;
  }
}

th, td {
  padding: 15px 10px;
  text-align: center;
}

th {
  width: 166px;
  
  &.normal {
    font-weight: normal;
  }
}

td {
  background: #fff;
  
  &:last-child {
    box-shadow: 20px 30px 30px rgba(0, 0, 0, 0.1);
  }
}

tr:last-child td {
  box-shadow: 20px 30px 30px rgba(0, 0, 0, 0.1);
}
</style>